import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'

const ChooseCard = (props) => {
    const {img, title, text, icon} = props.card
    return (
        <div>
        <Card style={{ width: '21rem', border: 'none'}}>
        <Card.Img variant="top" src={img} />
        <Card.Body>
            <div className="d-flex">
            <FontAwesomeIcon icon={icon} style={{color: '#F91944', marginRight: '10px'}} size="lg"/>
            <div>
            <Card.Title>{title}</Card.Title>
            <Card.Text style={{color: '#8E8E8E'}}>
            Keep your systems in sync with automated web hook based notification each time link is paid and how we dream about our future
            </Card.Text>
            <div className="d-flex">
            <b style={{color: '#5A7EF7'}}>See more</b>
            <FontAwesomeIcon icon={faArrowCircleRight} size="lg" style={{color: '#19E270', marginLeft: '10px'}}/>
            </div>
            </div>
            </div>
        </Card.Body>
        </Card>
        </div>
        
    );
};

export default ChooseCard;